'use client';
import React, { useEffect, useState } from 'react';

const Bar = () => {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            const scrollPercent = (scrollTop / docHeight) * 100;
            setScrollProgress(scrollPercent);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            <div className="fixed top-14 lg:top-24 z-10 left-0 w-full h-[2px]">
                <div className="h-[2px] bg-[#0b99ff] relative" style={{ width: `${scrollProgress}%` }}>
                    <div
                        className="absolute right-0 w-8 h-4 bg-[#0b99ff] rounded-b-full blur-md"
                        style={{
                            right: '-20px',
                            transform: `translateX(${scrollProgress}% -100%)`,
                            transition: 'transform 0.2s ease-out',
                        }}
                    />

                    {scrollProgress >= 100 && (
                        <div
                            className="border-solid border-[#0b99ff] bg-[#0b99ff]"
                            style={{
                                width: `${scrollProgress}%`,
                                background: `linear-gradient(to right, blue, white)`,
                                backgroundSize: '200% 100%',
                                backgroundPositionX: `${scrollProgress}%`,
                                transition: 'background-position 0.2s ease-out',
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Bar;
